import React from 'react';
import { Trophy, BookOpen, ClipboardList, Users, Brain, Target, MessageSquare, ShieldCheck } from 'lucide-react';
const tags = ['Sistema de juego 1-2-2', 'Sistema de juego 1-3-1', 'Presión alta', 'Salida limpia', 'Pelota parada', 'Evaluación por posición', 'Plan de temporada', 'Microciclo semanal', 'Charla técnica pre-partido', 'Gestión de conflictos', 'Motivación del grupo', 'Autoridad del DT'];
export function SystemBand() {
  return <section className="bg-cancha-dark text-white py-10 md:py-16 px-4 relative overflow-hidden" data-id="element-271">
      <div className="absolute inset-0 bg-field-pattern-dark opacity-20" data-id="element-272"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-273">
        <div className="flex flex-col items-center text-center mb-6 md:mb-10" data-id="element-274">
          <div className="inline-flex items-center gap-1.5 md:gap-2 bg-gold text-dark px-3 md:px-4 py-1 md:py-1.5 rounded-full font-bold text-xs md:text-sm mb-4 md:mb-6 uppercase tracking-wider" data-id="element-275">
            <Trophy size={14} className="md:w-4 md:h-4" data-id="element-276" />
            <span data-id="element-277">SISTEMA Nº1 EN ARGENTINA</span>
          </div>
          <h2 className="font-display text-3xl md:text-5xl mb-2 md:mb-4 uppercase leading-tight" data-id="element-278">
            Para entrenadores de futsal amateur
          </h2>
          <p className="text-base md:text-xl text-gray-300 font-medium max-w-2xl" data-id="element-279">
            Sistema completo · 6 Tomos + 6 Bonos · Entrenador Amateur · Todo
            resuelto.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 mb-6 md:mb-12" data-id="element-280">
          {[{
          icon: <BookOpen size={18} className="md:w-5 md:h-5" data-id="element-281" />,
          text: '+480 págs.'
        }, {
          icon: <ClipboardList size={18} className="md:w-5 md:h-5" data-id="element-282" />,
          text: '30+ planillas'
        }, {
          icon: <Target size={18} className="md:w-5 md:h-5" data-id="element-283" />,
          text: 'Táctica'
        }, {
          icon: <Brain size={18} className="md:w-5 md:h-5" data-id="element-284" />,
          text: 'Mentalidad'
        }].map((stat, i) => <div key={i} className="bg-white/10 border border-white/20 rounded-xl p-3 md:p-4 flex flex-col items-center justify-center gap-1.5 md:gap-2 backdrop-blur-sm" data-id="element-285">
              <div className="text-gold" data-id="element-286">{stat.icon}</div>
              <span className="font-bold text-sm md:text-base" data-id="element-287">
                {stat.text}
              </span>
            </div>)}
        </div>

        <div className="bg-white/5 rounded-2xl p-4 md:p-8 border border-white/10" data-id="element-288">
          <p className="text-center text-gold font-bold mb-4 md:mb-6 uppercase tracking-wider text-xs md:text-sm" data-id="element-289">
            Habilidades incluidas:
          </p>
          <div className="flex flex-wrap justify-center gap-1.5 md:gap-3" data-id="element-290">
            {tags.map((tag, i) => <span key={i} className="bg-white/10 hover:bg-white/20 transition-colors px-2 md:px-3 py-1 md:py-1.5 rounded-md md:rounded-lg text-[11px] md:text-sm font-medium border border-white/10" data-id="element-291">
                {tag}
              </span>)}
          </div>
        </div>

        <p className="text-center mt-6 md:mt-8 text-gray-400 font-medium text-xs md:text-base" data-id="element-292">
          Funciona desde hoy en tu club, cancha de barrio o liga zonal.
        </p>
      </div>
    </section>;
}